import { useState } from "react";

export function CellSignaling() {
  const [step, setStep] = useState(0);
  
  const handleNext = () => {
    setStep((prevStep) => (prevStep + 1) % 4);
  };

  return (
    <div className="relative w-full h-full flex items-center justify-center" onClick={handleNext}>
      <svg width="90%" height="90%" viewBox="0 0 600 300" xmlns="http://www.w3.org/2000/svg">
        {/* Cell membrane */}
        <path 
          d="M50,150 C50,120 550,120 550,150 C550,180 50,180 50,150" 
          fill="#ECF0F1" 
          stroke="#7F8C8D" 
          strokeWidth="4" 
        />
        
        {/* Cell interior */}
        <rect x="50" y="150" width="500" height="100" fill="#EBF5FB" />
        
        {/* Cell nucleus */}
        <circle cx="300" cy="200" r="40" fill="#D6EAF8" stroke="#3498DB" strokeWidth="2" />
        <circle cx="290" cy="195" r="8" fill="#3498DB" />
        <circle cx="310" cy="185" r="6" fill="#3498DB" />
        <circle cx="305" cy="210" r="7" fill="#3498DB" />
        
        {/* Cell Receptor */}
        <rect x="250" y="120" width="30" height="60" fill="#2C3E50" rx="5" />
        
        {/* Label the parts */}
        <text x="300" y="100" textAnchor="middle" fill="#2C3E50" fontWeight="bold">
          Extracellular Space
        </text>
        <text x="300" y="275" textAnchor="middle" fill="#2C3E50" fontWeight="bold">
          Cell Interior
        </text>
        <text x="265" y="110" textAnchor="middle" fill="#2C3E50">
          Receptor
        </text>
        <text x="300" cy="200" textAnchor="middle" fill="#2C3E50">
          Nucleus
        </text>
        
        {/* Dynamic elements based on step */}
        {step >= 1 && (
          <>
            {/* Peptide approaching receptor */}
            <circle 
              cx={step === 1 ? "200" : "265"}  
              cy={step === 1 ? "100" : "120"} 
              r="12" 
              fill="#E74C3C" 
            />
            <text 
              x={step === 1 ? "200" : "265"} 
              y={step === 1 ? "90" : "110"} 
              textAnchor="middle" 
              fill="white" 
              fontSize="10"
            >
              P
            </text>
            <text x="200" y="80" textAnchor="middle" fill="#2C3E50">
              Peptide
            </text>
          </>
        )}
        
        {step >= 2 && (
          <>
            {/* Signaling cascade */}
            <circle cx="265" cy="200" r="8" fill="#F39C12" />
            <circle cx="265" cy="220" r="8" fill="#F39C12" />
            <circle cx="265" cy="240" r="8" fill="#F39C12" />
            
            <line x1="265" y1="180" x2="265" y2="195" stroke="#F39C12" strokeWidth="2" strokeDasharray="4 2" />
            <line x1="265" y1="205" x2="265" y2="215" stroke="#F39C12" strokeWidth="2" strokeDasharray="4 2" />
            <line x1="265" y1="225" x2="265" y2="235" stroke="#F39C12" strokeWidth="2" strokeDasharray="4 2" />
            
            <text x="250" y="200" textAnchor="end" fill="#2C3E50" fontSize="10">
              Signaling
            </text>
            <text x="250" y="212" textAnchor="end" fill="#2C3E50" fontSize="10">
              Molecules
            </text>
          </>
        )}
        
        {step >= 3 && (
          <>
            {/* Cell response */}
            <line x1="280" y1="240" x2="320" y2="220" stroke="#2ECC71" strokeWidth="2" strokeDasharray="4 2" />
            <path d="M315,220 L325,220 L320,230 Z" fill="#2ECC71" />
            
            <text x="350" y="230" textAnchor="start" fill="#2C3E50" fontSize="10">
              Cell Response
            </text>
            <text x="350" y="242" textAnchor="start" fill="#2C3E50" fontSize="10">
              (Gene Expression)
            </text>
          </>
        )}
      </svg>
      
      <div className="absolute bottom-4 left-0 right-0 text-center text-sm text-[#7F8C8D]">
        {step === 0 && "Click to see peptide signaling in action"}
        {step === 1 && "1. Peptide binds to receptor"}
        {step === 2 && "2. Receptor activates signaling cascade"}
        {step === 3 && "3. Cell changes behavior in response"}
      </div>
    </div>
  );
}
